import { MYPAGE_RECEIPT_REQUEST } from "constants/action-types";

export const downloadReceipt = (id, name) => {
  const token = sessionStorage.getItem("token");

  return {
    type: MYPAGE_RECEIPT_REQUEST,
    payload: {
      request: {
        url: "selling/my-page/receipt",
        method: "GET",
        responseType: "blob",
        headers: {
          'Cache-Control': 'no-cache',
          Authorization: `Bearer ${token}`
        },
        params: {
          id,
          name
        }
      }
    }
  };
};



// WEBPACK FOOTER //
// ./src/actions/mypage/receipt.js